import DoctorRealtimeActions from './doctor-realtime-actions';
import angular from 'angular';
export default angular
    .module('doxy.realtime.components.DoctorRealtimeActions', [])
    .service('doctorRealtimeActions', DoctorRealtimeActions).name;
